export default "__VITE_ASSET__33ad904f__"